export const dayContentClassName = 'custom-day-content';
export const datePickerClassName = 'date-picker';
/**
 * Full list of parameters:
 * https://date-fns.org/v2.29.3/docs/format
 */
export var DATE_FORMAT;
(function (DATE_FORMAT) {
    DATE_FORMAT["MMM"] = "MMM";
    DATE_FORMAT["P"] = "P";
    DATE_FORMAT["d"] = "d";
    DATE_FORMAT["MMM y"] = "MMM y";
    DATE_FORMAT["MMMM y"] = "MMMM y";
    DATE_FORMAT["MM/dd/yyyy"] = "MM/dd/yyyy";
    DATE_FORMAT["dd/MM/yyyy"] = "dd/MM/yyyy";
    DATE_FORMAT["dd-MM-yyyy"] = "dd-MM-yyyy";
    DATE_FORMAT["yyyy-MM-dd"] = "yyyy-MM-dd";
    DATE_FORMAT["yyyy/MM/dd"] = "yyyy/MM/dd";
    DATE_FORMAT["yyyy-MM-dd'T'HH:mm"] = "yyyy-MM-dd'T'HH:mm";
    DATE_FORMAT["dd.MM.yyyy"] = "dd.MM.yyyy";
})(DATE_FORMAT || (DATE_FORMAT = {}));
export const DEFAULT_DROPDOWN_RANGE_FROM = 1900;
export const DEFAULT_DROPDOWN_RANGE_TO = new Date().getFullYear();
export const DEFAULT_INPUT_PLACEHOLDER_SINGLE = 'dd/mm/yyyy';
export const DEFAULT_INPUT_PLACEHOLDER_RANGE = 'from - to';
/**
 * DEFAULT_DATE_FORMAT should be 'P' to format date according to globally set locale,
 * however date-fns has a bug in 'parse' method and can't parse correctly different locales (e.g. nl, ru, etc.)
 */
export const DEFAULT_DATE_FORMAT = DATE_FORMAT['dd/MM/yyyy'];
